<template>
  <div v-on-clickaway="closeSelector" class="relative">
    <button
      v-tooltip="$t('CONVERSATION.CARD_CONTEXT_MENU.SNOOZE.TITLE')"
      class="flex items-center justify-center w-8 h-8 p-2 rounded-[4px] border border-solid border-gray-200 bg-white text-gray-600 shadow-[0px_1px_8px_0px_rgba(221,221,221,0.25)] hover:bg-gray-50 transition-colors cursor-pointer outline-none"
      @click="toggleSelector"
    >
      <span class="material-symbols-outlined text-[16px] leading-none">
        alarm
      </span>
    </button>
    <dropdown-panel
      v-if="isOpenSelector"
      :items="snoozeOptions"
      :searchable="false"
      :direction="isRTLView ? 'left-0' : 'right-0'"
      @select="snoozeConversation"
    >
      <template #item="{ item }">
        <span class="my-[3px]">{{ item.name }}</span>
      </template>
    </dropdown-panel>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { addHours, addDays, formatISO } from 'date-fns';
import alertMixin from 'shared/mixins/alertMixin';
import rtlMixin from 'shared/mixins/rtlMixin';
import DropdownPanel from './DropdownPanel.vue';

export default {
  components: { DropdownPanel },
  mixins: [alertMixin, rtlMixin],
  data() {
    return {
      isOpenSelector: false,
    };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
    snoozeOptions() {
      const hours = Array(24)
        .fill(1)
        .map((value, i) => {
          return {
            value: value + i,
            unit: 'hour',
            name: `${value + i} ${this.$t('CONTACT_PANEL.HOURS')}`,
          };
        });
      const days = Array(6)
        .fill(1)
        .map((value, i) => {
          return {
            value: value + i + 1,
            unit: 'day',
            name: `${value + i + 1} ${this.$t('CONTACT_PANEL.DAYS')}`,
          };
        });

      return hours.concat(days);
    },
  },
  methods: {
    toggleSelector() {
      this.isOpenSelector = !this.isOpenSelector;
    },
    closeSelector() {
      this.isOpenSelector = false;
    },
    snoozeConversation(option) {
      const isDay = option.unit === 'day';

      this.showSnoozeDropdown = false;
      this.$store
        .dispatch('toggleStatus', {
          conversationId: this.currentChat.id,
          status: 'snoozed',
          snoozedUntil: isDay
            ? formatISO(addDays(new Date(), option.value))
            : formatISO(addHours(new Date(), option.value)),
        })
        .then(() => {
          this.showAlert(this.$t('CONTACT_PANEL.SNOOZED_SUCCESS'));
        });
      this.closeSelector();
    },
  },
};
</script>
